export default __webpack_public_path__ + "static/media/thin-down-arrow.afc57839.svg";